import { put, takeLatest, all, call } from 'redux-saga/effects';
import {
  setAction,
  getInvitationsAction,
  resendInvitationAction,
  getPlanDetailsAction,
} from '../actions/teamInvitationsPage';
import React from 'react';
import actionTypes from '../../../redux/actions/action-types';

import {
  getTeamInvitesWithTeamid,
  postTeamInvitationUsingTeamid,
  delTeamInvitationUsingTeamidAndInviteid,
  postTeamInvitationResendUsingTeamid,
  getTeamSubscriptionSummaryWithTeamid,
} from '../../../api/cloudApiGenerated';

export function* getInvitations(params) {
  let { team } = params.data;

  yield put(
    setAction({
      dataReturned: false,
    })
  );

  try {
    let data = yield call(getTeamInvitesWithTeamid, team.id);
    yield put(
      setAction({
        invitations: data.data,
        inviteError: '',
        dataReturned: true,
      })
    );
  } catch (error) {
    yield put(
      setAction({
        error: 'loading team invites: ' + error.message || error.toString(),
      })
    );
  }
}

export function* getPlanDetails(params) {
  let { team, config } = params.data;

  if (!config.billing.enabled) return;

  try {
    let data = yield call(getTeamSubscriptionSummaryWithTeamid, team.id);
    yield put(
      setAction({
        unitPrice: data.unitPrice,
        priceTotal: data.priceTotal,
      })
    );
  } catch (error) {
    yield put(
      setAction({
        error: 'loading sub details: ' + error.message || error.toString(),
      })
    );
  }
}

export function* resendInvitation(params) {
  let { team, invitation } = params.data;

  try {
    invitation.sending = true;
    yield call(postTeamInvitationResendUsingTeamid, team.id, { email: invitation.email });
    invitation.sending = false;
    yield put(
      setAction({
        resend: true,
      })
    );
  } catch (e) {}
}

export function* setInvitations(params) {
  let { team, division, emailText, groupId, config } = params.data;

  if (groupId === '') {
    yield put(
      setAction({
        inviteError: 'Please select a group before continuing.',
      })
    );
    return;
  }

  const trim = emailText.replace(/\s/g, '');
  const emails = trim.split(',');

  let transactions = [];
  emails.forEach((email) => {
    transactions.push(
      call(postTeamInvitationUsingTeamid, team.id, {
        email,
        target_group: groupId,
        division: division.id,
      })
    );
  });

  try {
    yield all(transactions);

    yield put(getInvitationsAction({ team }));
    yield put(getPlanDetailsAction({ team, config }));

    yield put(setAction({ groupId: '', emailText: '', modalIsOpen: false }));
  } catch (e) {
    yield put(
      setAction({
        error: 'sending invite: ' + e.message && e.message.join(' '),
        inviteError: '',
      })
    );
  }
}

export function* deleteInvitation(params) {
  let { team, inviteId, config } = params.data;

  try {
    let data = yield call(delTeamInvitationUsingTeamidAndInviteid, team.id, inviteId);

    yield put(getInvitationsAction({ team }));
    yield put(getPlanDetailsAction({ team, config }));
    yield put(
      setAction({
        inviteId: '',
        showCancelInvitation: false,
      })
    );
  } catch (error) {
    yield put(
      setAction({
        error: 'cancelling invite: ' + error.message && error.message.join(' '),
      })
    );
  }
}

export function* deleteInvitations(params) {
  let { team, invites, config } = params.data;

  let invitesToDelete = [];
  invites.forEach((invite) => {
    if (invite) invitesToDelete.push(call(delTeamInvitationUsingTeamidAndInviteid, team.id, invite.id));
  });

  try {
    yield all(invitesToDelete);
    yield put(getInvitationsAction({ team }));
    yield put(getPlanDetailsAction({ team, config }));
    yield put(
      setAction({
        inviteId: '',
        showCancelInvitation: false,
      })
    );
  } catch (error) {
    yield put(
      setAction({
        error: 'cancelling invite: ' + error.response.message && error.response.message.join(' '),
      })
    );
  }
}

/** Watch functions */
export function* watchGetInvitations() {
  yield takeLatest(actionTypes.teamInvitationsPage.getInvitations, getInvitations);
}
export function* watchSetInvitations() {
  yield takeLatest(actionTypes.teamInvitationsPage.setInvitations, setInvitations);
}
export function* watchResendInvitation() {
  yield takeLatest(actionTypes.teamInvitationsPage.resendInvitation, resendInvitation);
}
export function* watchDeleteInvitation() {
  yield takeLatest(actionTypes.teamInvitationsPage.deleteInvitation, deleteInvitation);
}
export function* watchDeleteInvitations() {
  yield takeLatest(actionTypes.teamInvitationsPage.deleteInvitations, deleteInvitations);
}
export function* watchGetPlanDetails() {
  yield takeLatest(actionTypes.teamInvitationsPage.getPlanDetails, getPlanDetails);
}

export default function* rootSaga() {
  yield all([
    watchGetInvitations(),
    watchSetInvitations(),
    watchDeleteInvitations(),
    watchDeleteInvitation(),
    watchResendInvitation(),
  ]);
}
